function PostSpinModal({
  show,
  onClose,
  onLogin,
  onTopUp,
  isLoggedIn,
  hasEnoughBalance,
}) {
  if (!show) return null;

  return (
    <div className="modal-overlay modal-overlay-postspin">
      <div className="modal-content modal-content-postspin">
        <button
          onClick={onClose}
          className="close-button-postspin"
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f0f0f0";
            e.target.style.color = "#000";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "none";
            e.target.style.color = "#666";
          }}
        >
          ×
        </button>

        <h3 style={{ marginBottom: "20px", color: "#333", marginTop: "10px" }}>
          Want More Spins?
        </h3>

        {!isLoggedIn ? (
          <>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Login to get more spins and unlock premium features!
            </p>
            <div
              style={{ display: "flex", gap: "10px", justifyContent: "center" }}
            >
              <button onClick={onLogin} className="login-btn-postspin">
                Login Now
              </button>
              <button onClick={onClose} className="later-btn-postspin">
                Later
              </button>
            </div>
          </>
        ) : !hasEnoughBalance ? (
          <>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Your balance is low. Add funds to continue spinning!
            </p>
            <div
              style={{ display: "flex", gap: "10px", justifyContent: "center" }}
            >
              <button onClick={onTopUp} className="addfunds-btn-postspin">
                Add Funds
              </button>
              <button onClick={onClose} className="later-btn-postspin">
                Later
              </button>
            </div>
          </>
        ) : (
          <>
            <p style={{ marginBottom: "20px", color: "#666" }}>
              Continue spinning with your account balance!
            </p>
            <button onClick={onClose} className="continue-btn-postspin">
              Continue
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default PostSpinModal;
